export interface Movie {
  id: string;
  title: string;
  englishTitle: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  duration: string;
  region: string;
  director: string;
  actors: string[];
  description: string;
  image: string;
  isHot: boolean;
  isNew: boolean;
  views: number;
}

export const categories = [
  { name: '动作片', slug: 'action', icon: 'ri-sword-line' },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-happy-line' },
  { name: '爱情片', slug: 'romance', icon: 'ri-heart-line' },
  { name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line' },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line' },
  { name: '剧情片', slug: 'drama', icon: 'ri-film-line' },
  { name: '动画片', slug: 'animation', icon: 'ri-palette-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
  { name: '悬疑片', slug: 'thriller', icon: 'ri-search-eye-line' },
  { name: '战争片', slug: 'war', icon: 'ri-shield-flash-line' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 8.9,
    duration: '148分钟',
    region: '中国大陆',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代挺身而出，展开一场跨越时空的拯救行动。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20sci-fi%20space%20adventure%2C%20astronauts%20in%20futuristic%20spacesuits%20looking%20at%20distant%20planet%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20dark%20blue%20and%20orange%20color%20palette%2C%20clean%20composition%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=movie-poster-01&orientation=portrait',
    isHot: true,
    isNew: true,
    views: 1250000,
  },
  {
    id: 'movie-2',
    title: '封神第二部',
    englishTitle: 'Creation of the Gods II',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 8.5,
    duration: '156分钟',
    region: '中国大陆',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    description: '殷商末年，纣王暴虐无道。姬发在姜子牙的帮助下，召集天下英雄，踏上讨伐纣王的征程，一场关乎天下苍生的大战即将拉开帷幕。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%2C%20ancient%20warriors%20in%20traditional%20armor%20with%20mythical%20beasts%2C%20dramatic%20red%20and%20gold%20color%20scheme%2C%20ancient%20Chinese%20palace%20background%2C%20cinematic%20lighting%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-02&orientation=portrait',
    isHot: true,
    isNew: true,
    views: 980000,
  },
  {
    id: 'movie-3',
    title: '热辣滚烫',
    englishTitle: 'YOLO',
    year: 2024,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 7.8,
    duration: '129分钟',
    region: '中国大陆',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    description: '乐莹是一个善良的女孩，但在生活中总是被人欺负。一次偶然的机会让她接触到了拳击运动，她的人生从此发生了翻天覆地的变化。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20and%20inspiring%20comedy%20movie%20poster%2C%20woman%20boxing%20gloves%20with%20confident%20smile%2C%20bright%20warm%20lighting%2C%20pink%20and%20golden%20color%20tones%2C%20motivational%20atmosphere%2C%20clean%20simple%20background%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-03&orientation=portrait',
    isHot: true,
    isNew: false,
    views: 2100000,
  },
  {
    id: 'movie-4',
    title: '奥本海默',
    englishTitle: 'Oppenheimer',
    year: 2023,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 8.8,
    duration: '180分钟',
    region: '美国',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙'],
    description: '讲述了美国"原子弹之父"罗伯特·奥本海默在二战期间领导曼哈顿计划研制原子弹的故事，以及战后他面对的道德困境和政治迫害。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20biographical%20movie%20poster%2C%20man%20silhouette%20against%20nuclear%20explosion%2C%20intense%20orange%20and%20black%20contrast%2C%20serious%20and%20contemplative%20mood%2C%20artistic%20composition%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-04&orientation=portrait',
    isHot: true,
    isNew: false,
    views: 890000,
  },
  {
    id: 'movie-5',
    title: '消失的她',
    englishTitle: 'Lost in the Stars',
    year: 2023,
    category: '悬疑片',
    categorySlug: 'thriller',
    rating: 7.5,
    duration: '122分钟',
    region: '中国大陆',
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊'],
    description: '何非的妻子在海外旅行时神秘失踪，当他报案后，一个陌生女人突然出现声称是他的妻子。随着调查的深入，一个惊人的真相逐渐浮出水面。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%2C%20woman%20face%20half%20hidden%20in%20shadow%2C%20dark%20blue%20and%20teal%20color%20tones%2C%20suspenseful%20atmosphere%2C%20tropical%20island%20background%20hint%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-05&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 750000,
  },
  {
    id: 'movie-6',
    title: '熊出没·逆转时空',
    englishTitle: 'Boonie Bears: Time Twist',
    year: 2024,
    category: '动画片',
    categorySlug: 'animation',
    rating: 8.2,
    duration: '99分钟',
    region: '中国大陆',
    director: '林汇达',
    actors: ['张伟', '张秉君', '谭笑'],
    description: '光头强在森林中偶然发现了一个神秘的时间装置，意外穿越到了不同的时代。他与熊大熊二一起，踏上了一段跨越时空的奇妙冒险之旅。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20family%20movie%20poster%2C%20cartoon%20bears%20in%20time%20travel%20adventure%2C%20vibrant%20colors%2C%20whimsical%20fantasy%20elements%2C%20playful%20and%20fun%20atmosphere%2C%20professional%20animation%20film%20poster&width=600&height=900&seq=movie-poster-06&orientation=portrait',
    isHot: false,
    isNew: true,
    views: 620000,
  },
  {
    id: 'movie-7',
    title: '你的婚礼',
    englishTitle: 'My Love',
    year: 2021,
    category: '爱情片',
    categorySlug: 'romance',
    rating: 6.8,
    duration: '115分钟',
    region: '中国大陆',
    director: '韩天',
    actors: ['许光汉', '章若楠'],
    description: '高中时期，转学生周潇齐对尤咏慈一见钟情。两人经历了十五年的分分合合，从校园到社会，一段跨越漫长岁月的青涩爱情故事。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20youth%20movie%20poster%2C%20young%20couple%20smiling%20under%20cherry%20blossoms%2C%20soft%20pastel%20pink%20and%20white%20tones%2C%20dreamy%20atmosphere%2C%20school%20uniform%2C%20professional%20romantic%20film%20poster&width=600&height=900&seq=movie-poster-07&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 550000,
  },
  {
    id: 'movie-8',
    title: '长津湖之水门桥',
    englishTitle: 'The Battle at Lake Changjin II',
    year: 2022,
    category: '战争片',
    categorySlug: 'war',
    rating: 7.9,
    duration: '149分钟',
    region: '中国大陆',
    director: '徐克',
    actors: ['吴京', '易烊千玺', '段奕宏'],
    description: '抗美援朝战争期间，志愿军第七穿插连接到一项艰巨任务——炸毁水门桥，切断美军退路。在极寒环境下，战士们以血肉之躯铸就了钢铁防线。',
    image: 'https://readdy.ai/api/search-image?query=War%20epic%20movie%20poster%2C%20soldiers%20in%20snowy%20battlefield%2C%20dramatic%20winter%20combat%20scene%2C%20cold%20blue%20and%20white%20color%20palette%2C%20heroic%20and%20solemn%20mood%2C%20professional%20war%20film%20poster&width=600&height=900&seq=movie-poster-08&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 480000,
  },
  {
    id: 'movie-9',
    title: '咒',
    englishTitle: 'Incantation',
    year: 2022,
    category: '恐怖片',
    categorySlug: 'horror',
    rating: 7.2,
    duration: '111分钟',
    region: '中国台湾',
    director: '柯孟融',
    actors: ['蔡亘晏', '高英轩', '黄歆庭'],
    description: '六年前，李若男和朋友组成影像团队，闯入邪教仪式中的禁地，触怒了沉睡的邪灵。如今她必须回去解开诅咒，拯救自己和女儿。',
    image: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%2C%20eerie%20woman%20face%20with%20strange%20symbols%2C%20dark%20red%20and%20black%20tones%2C%20creepy%20atmosphere%2C%20found%20footage%20style%20aesthetic%2C%20professional%20horror%20film%20poster&width=600&height=900&seq=movie-poster-09&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 420000,
  },
  {
    id: 'movie-10',
    title: '地球脉动',
    englishTitle: 'Planet Earth III',
    year: 2024,
    category: '纪录片',
    categorySlug: 'documentary',
    rating: 9.5,
    duration: '60分钟/集',
    region: '英国',
    director: '尼克·伊斯顿',
    actors: ['大卫·爱登堡'],
    description: 'BBC自然纪录片系列的第三部，以前所未有的视角展现地球上最壮丽的自然景观和野生动物，从深海到高山，从极地到沙漠。',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20stunning%20landscape%20with%20wildlife%2C%20majestic%20mountains%20and%20oceans%2C%20vibrant%20natural%20colors%2C%20awe-inspiring%20beauty%2C%20professional%20documentary%20film%20poster&width=600&height=900&seq=movie-poster-10&orientation=portrait',
    isHot: false,
    isNew: true,
    views: 380000,
  },
  {
    id: 'movie-11',
    title: '满江红',
    englishTitle: 'Full River Red',
    year: 2023,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 7.6,
    duration: '159分钟',
    region: '中国大陆',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一群小人物被卷入一场巨大的阴谋之中，在有限的空间内上演了一场惊心动魄的权谋大戏。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%2C%20ancient%20Chinese%20courtyard%20with%20figures%20in%20traditional%20costumes%2C%20dark%20and%20mysterious%20atmosphere%2C%20red%20lanterns%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-11&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 650000,
  },
  {
    id: 'movie-12',
    title: '速度与激情10',
    englishTitle: 'Fast X',
    year: 2023,
    category: '动作片',
    categorySlug: 'action',
    rating: 7.0,
    duration: '141分钟',
    region: '美国',
    director: '路易斯·莱特里尔',
    actors: ['范·迪塞尔', '杰森·莫玛', '米歇尔·罗德里格兹'],
    description: '唐老大与他的家人面临前所未有的威胁——但丁，一个与过去的阴影紧密相连的危险敌人。为了守护所爱之人，他们必须再次出击。',
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%2C%20fast%20cars%20in%20explosive%20chase%20scene%2C%20dynamic%20orange%20and%20black%20color%20scheme%2C%20urban%20street%20racing%20vibe%2C%20professional%20action%20film%20poster&width=600&height=900&seq=movie-poster-12&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 430000,
  },
];

export const rankingMovies = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 10);

export const hotMovies = movies.filter(m => m.isHot);

export const newMovies = movies.filter(m => m.isNew);

export function getMoviesByCategory(slug: string): Movie[] {
  return movies.filter(m => m.categorySlug === slug);
}

export function getMovieById(id: string): Movie | undefined {
  return movies.find(m => m.id === id);
}

export function getRelatedMovies(movie: Movie, count: number = 4): Movie[] {
  return movies
    .filter(m => m.id !== movie.id && m.categorySlug === movie.categorySlug)
    .slice(0, count);
}